"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.footGaugeProductType = void 0;
const variant_attributes_1 = require("./variant-attributes");
const core_attributes_1 = require("./core-attributes");
const common_1 = require("./common");
exports.footGaugeProductType = {
    name: 'Foot Gauge',
    key: common_1.ProductTypesEnum.FOOT_GAUGE,
    description: 'Foot Gauge',
    attributes: [
        core_attributes_1.styleCode,
        core_attributes_1.styleName,
        core_attributes_1.shortColor,
        core_attributes_1.mediumColor,
        core_attributes_1.brand,
        core_attributes_1.productType,
        core_attributes_1.productSubType,
        core_attributes_1.season,
        core_attributes_1.seasonYear,
        core_attributes_1.seasonIntroduced,
        core_attributes_1.subBrand,
        core_attributes_1.gender,
        core_attributes_1.featureDescription,
        core_attributes_1.videoUrl,
        core_attributes_1.spinUrl,
        core_attributes_1.countryOfOrigin,
        core_attributes_1.vertexTaxGroup,
        // variant attributes
        (0, variant_attributes_1.globalSize)(),
        (0, variant_attributes_1.globalFit)(),
        variant_attributes_1.variantWeight,
        variant_attributes_1.variantLength,
        variant_attributes_1.variantWidth,
        variant_attributes_1.variantHeight,
        variant_attributes_1.ean,
        variant_attributes_1.upc,
        variant_attributes_1.ukFit,
        variant_attributes_1.usFit,
        variant_attributes_1.euFit,
        variant_attributes_1.ukSize,
        variant_attributes_1.usSize,
        variant_attributes_1.euSize,
        variant_attributes_1.pairsPerCarton,
    ],
};
//# sourceMappingURL=foot-gauge.js.map